import React from "react";
import { Select, MenuItem, FormControl, Box } from "@mui/material";

const BotFilter = ({ bots, selectedBot, setSelectedBot }) => {
  return (
    <Box sx={{ marginBottom: 2, width: "100%" }}>
      <FormControl fullWidth sx={{ marginTop: 4, marginBottom: 2 }}>
        <Select
          value={selectedBot}
          onChange={(e) => setSelectedBot(e.target.value)}
          displayEmpty
          sx={{
            color: "#ffffff",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: "#ffffff",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ffffff",
            },
            ".MuiSvgIcon-root": {
              color: "#ffffff",
            },
            width: "100%",
          }}
        >
          <MenuItem value="">
            <em>All Bots</em>
          </MenuItem>
          {bots.map((bot, index) => (
            <MenuItem key={index} value={bot.botName}>
              {bot.botName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default BotFilter;
